import type {
  CustomerMappableField,
  HostedFlowStep,
  PayloadFormQuestion,
} from "@portal/app/_server/services/formFunnel/payloadTypes";

/** Maps HostedFlowStep names that don't directly match a CustomerMappableField value */
const STEP_TO_CUSTOMER_FIELD: Partial<Record<HostedFlowStep, string>> = {
  addressZip: "address.zip",
};

/**
 * Dedicated hosted steps should never be rendered by HostedDynamicStep, even if
 * a global Payload question is mapped to the same conceptual field. Today only
 * phone directly collided, but keeping the whole built-in set here protects
 * contact/address/confirm if their routing keys are ever remapped later.
 */
const BUILT_IN_HOSTED_STEPS = new Set<HostedFlowStep>([
  "contact",
  "phone",
  "address",
  "confirm",
]);

/** Resolve the customerField for a hosted step. Most steps match 1:1. */
export function getCustomerFieldForStep(step: HostedFlowStep): string {
  return STEP_TO_CUSTOMER_FIELD[step] ?? step;
}

export function isBuiltInHostedStep(step: HostedFlowStep): boolean {
  return BUILT_IN_HOSTED_STEPS.has(step);
}

type CmsQuestionWithCustomerFieldMapping = Pick<
  PayloadFormQuestion,
  "customerFieldMapping"
> & {
  customerFieldMapping: NonNullable<PayloadFormQuestion["customerFieldMapping"]> & {
    customerField: CustomerMappableField;
  };
};

export function shouldRenderHostedDynamicStep(
  step: HostedFlowStep,
  cmsQuestion: Pick<PayloadFormQuestion, "customerFieldMapping"> | undefined
): cmsQuestion is CmsQuestionWithCustomerFieldMapping {
  return (
    !isBuiltInHostedStep(step) &&
    !!cmsQuestion?.customerFieldMapping?.customerField
  );
}
